import { zzfxP, zzfx } from './lib/zzfx';
import { zzfxM } from './lib/zzfxm';

let isMusicEnabled = false;
let myAudioNode = null;
let isPlaying = false;
let audioContext = window.zzfxX;

export const getIsMusicEnabled = () => {
  return isMusicEnabled;
};
export const getIsPlaying = () => {
  return isPlaying;
};
export const stopSong = () => {
  isPlaying = false;
  audioContext.suspend();
};
export const toggleSound = () => {
  if (isPlaying) {
    isMusicEnabled = false;
    stopSong();
  } else {
    isMusicEnabled = true;
    playSong();
  }
};

export const playBubble = () => {
  zzfx(
    ...[, 1, 7, 0.02, 0.01, 0.02, 4, 0.5, , , 1, 0.01, , , 150, , 0.21, , 0.01]
  ); // Blip 273
};
export const playDead = () => {
  zzfx(...[, , 326, , 0.06, 0.08, 1, 0.95, -6.8, , , , , , , , , 0.45, 0.08]); // Jump 299
};

export const playGoal = () => {
  zzfx(
    ...[
      ,
      ,
      269,
      0.07,
      0.21,
      0.3,
      1,
      0.94,
      8.3,
      -0.2,
      284,
      0.12,
      0.12,
      ,
      ,
      ,
      0.13,
      0.75,
      0.17,
    ]
  ); // Powerup 397
};
export const playPickup = () => {
  zzfx(
    ...[
      ,
      ,
      607,
      0.01,
      0.03,
      0.13,
      1,
      1.56,
      ,
      ,
      -490,
      0.04,
      0.02,
      ,
      ,
      ,
      ,
      0.47,
      0.02,
      0.03,
    ]
  ); // Pickup 368
};
export const playCutRope = () => {
  zzfx(
    ...[, , 1081, 0.01, 0.01, 0.02, 4, 1.1, 14, 32, , , , 0.8, , , 0.06, 0.66]
  ); // Blip 329
};
export const playSong = () => {
  isPlaying = true;
  if (myAudioNode) {
    audioContext.resume();
    return;
  }
  const song = [
    [
      [0.5, 0, 245, 0.07, 0.1, 0.65, , 1.5, , , , , , , , , , , 0.05, 1],
      [0.3, 0, 245, , , 3, 2, 0.3, , -0.001, , , , , , , 0.02, , , 0.04],
      [0.1, 0, 245, , , 2, 1, 0],
      [, 0, , , , , 4, , , , , , , , 100, 2],
    ],
    [
      [
        [
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          22.1,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
      ],
      [
        [
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
      ],
      [
        [
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          25,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          24,
          ,
          25,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          28,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
      ],
      [
        [
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          18,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          17,
          ,
          18,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          23,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
      ],
      [
        [
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          10,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          24,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          22,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          10.53,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          12.4,
          ,
          ,
          ,
          13.7,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          20,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          18,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          17,
          ,
          ,
          ,
        ],
      ],
      [
        [
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          18,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          29,
          ,
          ,
          ,
          25,
          ,
          ,
          ,
          22,
          ,
          ,
          ,
        ],
        [
          1,
          ,
          18,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          17,
          ,
          18,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          23.1,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
        ],
        [
          2,
          ,
          6,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          ,
          -1,
        ],
      ],
    ],
    [0, 1, 2, 3, 4, 5],
    ,
    {
      title: '',
      instruments: ['', '', '', ''],
      patterns: ['A1', 'A2', 'B1', 'B2', 'B3', 'B4'],
    },
  ];
  let mySongData = zzfxM(...song);

  myAudioNode = zzfxP(zzfxX, ...mySongData);
  myAudioNode.loop = true;
  return;
};
